
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embeds/projects/[projectId]/brainstormers/banner",
      function () {
        return require("private-next-pages/embeds/projects/[projectId]/brainstormers/banner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embeds/projects/[projectId]/brainstormers/banner"])
      });
    }
  